import { Delete } from '@mui/icons-material'
import { ReactElement } from 'react'
import styled from 'styled-components'
import { Button } from '../../../../../../src/ui-components/forms/Button'
import { defaultTheme } from '../../../../../../src/theme/index'

interface ProductCardCartActionsProps {
  inCart: boolean
  inStockSomewhere: boolean
  orderIfNotAvailable: boolean
  isCondensedView?: boolean
  addToCartDisabled: boolean
  addToCartInProgress: boolean
  inCartText: string
  onAddToCart: () => void
  onDelete: () => void
  showInCartClick?: boolean
  condensedButtonStyles?: boolean
  buttonWidth?: string
}

export const ProductCardCartActions = ({
  inCart,
  inStockSomewhere,
  orderIfNotAvailable,
  isCondensedView,
  addToCartDisabled,
  addToCartInProgress,
  inCartText,
  onAddToCart,
  onDelete,
  showInCartClick = false,
  condensedButtonStyles = false,
  buttonWidth = '100%',
}: ProductCardCartActionsProps): ReactElement => {
  const condensedStyle = condensedButtonStyles
    ? {
        height: isCondensedView && '32px',
        fontSize: isCondensedView && '14px',
        marginTop: isCondensedView && '12px',
      }
    : { marginTop: isCondensedView && '12px' }

  const canAdd = !inCart && (inStockSomewhere || orderIfNotAvailable)
  const showDisabledAdd = !inStockSomewhere && !orderIfNotAvailable

  return (
    <>
      {canAdd && (
        <ButtonWrapper
          $width={buttonWidth}
          style={{ marginTop: isCondensedView && 0 }}
        >
          <AddButton
            onClick={onAddToCart}
            text="addToCart"
            disabled={addToCartDisabled}
            style={condensedStyle}
            loading={addToCartInProgress}
          />
        </ButtonWrapper>
      )}
      {showDisabledAdd && (
        <ButtonWrapper
          $width={buttonWidth}
          style={{ marginTop: isCondensedView && 0 }}
        >
          <AddButton text="addToCart" disabled style={condensedStyle} />
        </ButtonWrapper>
      )}
      {inCart && (
        <ButtonWrapper $width={buttonWidth}>
          <AddButton
            text={inCartText}
            variant="success"
            style={
              condensedButtonStyles
                ? {
                    height: isCondensedView && '32px',
                    fontSize: isCondensedView && '14px',
                  }
                : undefined
            }
            onClick={showInCartClick ? onAddToCart : undefined}
          />
          <DeleteWrapper onClick={onDelete}>
            <DeleteButton />
          </DeleteWrapper>
        </ButtonWrapper>
      )}
    </>
  )
}

const ButtonWrapper = styled.div<{ $width: string }>`
  display: flex;
  align-items: center;
  margin: 10px 0 0;
  width: ${(p) => p.$width};
`

const DeleteWrapper = styled.div`
  padding: 0.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${defaultTheme.colors.siteBackground};
  cursor: pointer;
  border-radius: 3px;
  flex-basis: 48px;
`

const AddButton = styled(Button)`
  width: 100%;
  box-sizing: border-box;
  margin-left: 0px;
  margin-right: 0px;
`

const DeleteButton = styled(Delete)`
  color: ${defaultTheme.colors.greyDark};
`
